import type { AgentProfileState } from './types'
import type { Selector } from 'store'

import { createSelector } from '@reduxjs/toolkit'

import { NAME } from './constant'

export const selectAgentProfileState: Selector<AgentProfileState> = (state) => state[NAME]

export const selectAgentProfile: Selector<AgentProfile> = createSelector(
  selectAgentProfileState,
  (agentProfileState) => agentProfileState.data,
)
